module.exports = __webpack_public_path__ + "24e004ab/img/chevron-down-icon.5542f65c.svg";